
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        console.log('onSubmitHandler');
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
        this.handleErrorMessage();
      
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      
        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;
        console.log('formData: ',formData);  
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
      
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              console.log("!this cart")
              return;
            }

            // // if Anabella 25-28 is added we 2 items           
            // if (formData.get('id') == '44758137831666') {
            //   const itemsToAdd = [
            //     { id: '44920883970290', quantity: 1 }, // adjustable breastshield
            //     { id: '44921205850354', quantity: 1 } // free product
            //   ];
            
            //   fetch('/cart/add.js', {
            //     method: "post",
            //     headers: { 'content-type': 'application/json' },
            //     body: JSON.stringify({ items: itemsToAdd })
            //   })
            //   .then((response) => response.json())
            //   .then((data) => {
            //     //console.log("Products added to cart:", data);
            //     publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: '44920883970290', cartData: data });
            //     publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: '44921205850354', cartData: data });
                
            //     // Fetch the current cart data
            //     return fetch('/cart.js');
            //   })
            //   .then(response => response.json())
            //   .then(cart => {
            //     // Find the cart count bubble element
            //     const cartCountBubble = document.querySelector('.cart-count-bubble');
            
            //     // Update the cart count bubble with the current cart item count
            //     if (cartCountBubble) {
            //       cartCountBubble.textContent = cart.item_count;
            //     }
            //     const totalPriceElement = document.querySelector('.qc_tot_val');
            //     if (totalPriceElement) {
            //         totalPriceElement.textContent = `$${(cart.total_price / 100.0).toFixed(2)}`;
            //     }
            //   })
            //   .catch((error) => {
            //     console.error("Error adding products:", error);
            //   });
            // }
            
            
            // // if Anabella 18-24 is added we free product 
            // if (formData.get('id') == '44758137798898') {
            //   const itemsToAdd = [
            //     { id: '44921205850354', quantity: 1 } // free product
            //   ];
            
            //   fetch('/cart/add.js', {
            //     method: "post",
            //     headers: { 'content-type': 'application/json' },
            //     body: JSON.stringify({ items: itemsToAdd })
            //   })
            //   .then((response) => response.json())
            //   .then((data) => {
            //     //console.log("Product added to cart:", data);
            //     publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: '44921205850354', cartData: data });
                
            //     // Fetch the current cart data
            //     return fetch('/cart.js');
            //   })
            //   .then(response => response.json())
            //   .then(cart => {
            //     // Find the cart count bubble element
            //     const cartCountBubble = document.querySelector('.cart-count-bubble');
            
            //     // Update the cart count bubble with the current cart item count
            //     if (cartCountBubble) {
            //       cartCountBubble.textContent = cart.item_count;
            //     }
                
            //   })
            //   .catch((error) => {
            //     console.error("Error adding product:", error);
            //   });
            // }

            
      
            // If the added variant ID is 44758137831666, add another product with ID 8045057704178
            // if (formData.get('id') == '44758137831666') {
            //   const additionalProductFormData = new FormData();
            //   additionalProductFormData.append('id', '44920883970290');                                                      
            //   additionalProductFormData.append('quantity', '1');
      
            //   const additionalProductConfig = fetchConfig('javascript');
            //   additionalProductConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
            //   delete additionalProductConfig.headers['Content-Type'];
            //   additionalProductConfig.body = additionalProductFormData;
            //   console.log("FETCHING");
            //   fetch(`${routes.cart_add_url}`, additionalProductConfig)
            //   .then((response) => response.json())
            //   .then((response) => {
            //     console.log("RESPONSE: ", response);
            //     publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: '44920883970290', cartData: response });
            //     // Fetch the current cart data
            //     fetch('/cart.js')
            //     .then(response => response.json())
            //     .then(cart => {
            //       // Find the cart count bubble element
            //       const cartCountBubble = document.querySelector('.cart-count-bubble');

            //       // Update the cart count bubble with the current cart item count
            //       if (cartCountBubble) {
            //         cartCountBubble.textContent = cart.item_count;
            //       }
            //     });
            //   })
            //   console.log('additionalProductConfig: ',additionalProductConfig);              
            // }
      
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
